import React from 'react';

import {
  ORDER_DETAIL_MODAL_TITLE,
  ORDER_DETAIL_MODAL_MESSAGE,
  ORDER_DETAIL_MODAL_INFO,
} from './constants';

import styles from './styles.module.scss';

export const OrderDetailsModal: React.FC<sharedComponents.OrderDetailsModal> = ({ orderReference }) => (
  <div className={styles.detailsModalContent}>
    <h2>{ORDER_DETAIL_MODAL_TITLE}</h2>
    <p>{ORDER_DETAIL_MODAL_INFO}</p>
    <p><strong>{orderReference}</strong>{ORDER_DETAIL_MODAL_MESSAGE}</p>
  </div>
);
